export const Modal = ({
  modalId,
  children,
  title,
  dismissBtnRef,
  onClickClose,
}) => {
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ marginLeft: "20px", marginRight: "20px" }}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: "#1c1e23",
            color: "white",
            border: "1px solid #262626",
          }}
        >
          <div className="d-flex align-items-center justify-content-between custom-border-bottom p-3">
            <h1
              className="modal-title text-font4"
              id="exampleModalLabel"
              style={{ width: "100%" }}
            >
              {title}
            </h1>
            <i
              className="bi bi-x modal-close cursor-pointer fs-3"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={dismissBtnRef}
              onClick={onClickClose}
            />
          </div>
          <div className="modal-body p-0 text-font3">{children}</div>
        </div>
      </div>
    </div>
  );
};
